import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { NotifyProvider } from './components/common';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyEmail from './pages/auth/VerifyEmail';
import VerifyEmailSuccess from './pages/auth/VerifyEmailSuccess';
import VerifyEmailError from './pages/auth/VerifyEmailError';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import MyAccount from './pages/MyAccount';
import Dashboard from './pages/admin/Dashboard';
import OnlineUsers from './pages/admin/OnlineUsers';
import Users from './pages/admin/Users';
import UserDetail from './pages/admin/UserDetail';
import Subscriptions from './pages/admin/Subscriptions';
import Plans from './pages/admin/Plans';
import Agents from './pages/admin/Agents';
import AgentReleases from './pages/admin/AgentReleases';
import History from './pages/admin/History';

const HomeRedirect = () => {
  const { user } = useAuth();
  return <Navigate to={user?.isAdmin ? '/admin' : '/settings'} replace />;
};

function App() {
  return (
    <AuthProvider>
      <ThemeModeProvider>
        <NotifyProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/verify-email-success" element={<VerifyEmailSuccess />} />
              <Route path="/verify-email-error" element={<VerifyEmailError />} />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <MyAccount />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <PrivateRoute adminOnly>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="online" element={<OnlineUsers />} />
                <Route path="users" element={<Users />} />
                <Route path="users/:id" element={<UserDetail />} />
                <Route path="subscriptions" element={<Subscriptions />} />
                <Route path="plans" element={<Plans />} />
                <Route path="agents" element={<Agents />} />
                <Route path="agent-releases" element={<AgentReleases />} />
                <Route path="history" element={<History />} />
              </Route>
              <Route
                path="*"
                element={
                  <PrivateRoute>
                    <HomeRedirect />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
        </NotifyProvider>
      </ThemeModeProvider>
    </AuthProvider>
  );
}

export default App;
